/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AuditLogRequest} from '../models/AuditLogRequest';
import type {Error} from '../models/Error';
import type {SsoAuditLogResponse} from '../models/SsoAuditLogResponse';

export interface GetSsoAuditLog$Request {
    auditLogRequest: AuditLogRequest;
}

export interface GetSsoAuditLog$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSsoAuditLogRequest = createAction<PayloadData<void, GetSsoAuditLog$Request>>('SSO_AUDIT__GET_SSO_AUDIT_LOG__REQUEST');
export const getSsoAuditLogSuccess = createAction<PayloadData<SsoAuditLogResponse, GetSsoAuditLog$Request>>('SSO_AUDIT__GET_SSO_AUDIT_LOG__SUCCESS');
export const getSsoAuditLogFailure = createAction<PayloadData<Error, GetSsoAuditLog$Request, true>>('SSO_AUDIT__GET_SSO_AUDIT_LOG__FAILURE');

export const getSsoAuditLogActions = [
    getSsoAuditLogRequest,
    getSsoAuditLogSuccess,
    getSsoAuditLogFailure
] as const;

/**
 * Get audit log entries for an account
 * @param {AuditLogRequest} meta.auditLogRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSsoAuditLog = (meta: GetSsoAuditLog$Request, config?: GetSsoAuditLog$Config) => {
    return {
        CALL_API: {
            types: getSsoAuditLogActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/sso/audit-log`,
            TRANSPORT_REQUEST_BODY: meta.auditLogRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

